import { Status } from '@/redux/types/room'

type WithStatus = { status?: string | null }

/** The owner and accepted members are in the chat. */
export const isInGroupChat = (member: WithStatus): boolean =>
  member.status === Status.Owner || member.status === Status.Accepted

/** Invited, not yet answered. */
export const isInvitedToGroupChat = (member: WithStatus): boolean =>
  member.status === Status.Pending

/**
 * Declined or removed. They are not counted, named or shown, and can be
 * invited again.
 */
export const hasLeftGroupChat = (member: WithStatus): boolean =>
  member.status === Status.Rejected || member.status === Status.Terminated
